export default function generateModulesList(async_modules_path, file_server_url, automation_modules_path) {
    return [
        /* GH ELEMENTS */
        {
            data_type: "text",
            name: "Text",
            icon: "text_icon",
            url: file_server_url + '/' + async_modules_path + "text_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "text_opt",
            name: "Options",
            icon: "option_gh_element",
            url: file_server_url + '/' + async_modules_path + "text_options_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "number",
            name: "Number",
            icon: "number",
            url: file_server_url + '/' + async_modules_path + "number_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "task_board",
            name: "Task Board",
            icon: "task_board",
            url: file_server_url + '/' + async_modules_path + "task_board_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "visualizer",
            name: "visualizer",
            icon: 'visualizer',
            url: file_server_url + '/' + async_modules_path + "visualizer_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "enterprice_visualizer",
            name: "Enterprice Visualizer",
            icon: "visualizer",
            private: true,
            url: file_server_url + '/' + async_modules_path + "enterprice_visualizer_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "email",
            name: "Email",
            icon: "email",
            url: file_server_url + '/' + async_modules_path + "email_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: 'date',
            name: "Date",
            icon: "date_gh_element",
            url: file_server_url + '/' + async_modules_path + "date_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: 'radio_button',
            name: "Radio Button",
            icon: "radio_button_gh_element",
            url: file_server_url + '/' + async_modules_path + "radio_button_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: 'radio_icon',
            name: "Radio icon",
            icon: "radio_icon_gh_element",
            url: file_server_url + '/' + async_modules_path + "radio_icon_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: 'twilio_phone',
            name: "Twilio Phone",
            icon: "phone_twilio_gh_element",
            url: file_server_url + '/' + async_modules_path + "twilio_phone_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "twilio_autodialer",
            name: "Twilio Auto Dialer",
            icon: "twilio_dialer",
            url: file_server_url + '/' + async_modules_path + "twillio_autodialer_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "color",
            name: "Color",
            icon: "paint_gh_element",
            url: file_server_url + '/' + async_modules_path + "color_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "charts",
            name: "Charts",
            icon: "graph_gh_element",
            url: file_server_url + '/' + async_modules_path + "charts_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: 'funnel_chart',
            name: "Funnel chart",
            icon: "funnel_chart_gh_element",
            url: file_server_url + '/' + async_modules_path + "funnel_chart_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "add_items_from_template",
            name: "Add items from template",
            icon: "contact_second",
            url: file_server_url + '/' + async_modules_path + "add_items_from_template_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "item_ref",
            name: "Reference",
            icon: "reference",
            url: file_server_url + '/' + async_modules_path + "itemRef_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "calendar",
            name: 'Calendar',
            icon: 'calendar',
            js: 'https://gudhub.com/modules/FullCalendar-Gh-Element/dist/main.js?t=4',
            css: 'https://gudhub.com/modules/FullCalendar-Gh-Element/dist/style.css?t=1',
            type: 'gh_element',
            technology: "class"
        },
        {
            data_type: "data_ref",
            name: 'Data Reference',
            icon: 'data_reference',
            url: file_server_url + '/' + async_modules_path + "data_ref_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "table",
            name: 'Table',
            icon: 'table',
            url: file_server_url + '/' + async_modules_path + "table_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "tile",
            name: 'Tile table',
            icon: 'tile_table',
            url: file_server_url + '/' + async_modules_path + "tile_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "file",
            name: 'File',
            icon: 'box',
            url: file_server_url + '/' + async_modules_path + "file_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "image",
            name: 'Image',
            icon: 'image',
            url: file_server_url + '/' + async_modules_path + "image_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "text_editor",
            name: 'Text Editor',
			icon: 'square',
            url: file_server_url + '/' + async_modules_path + "text_editor_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "tinymse",
            name: 'Text editor MSE',
            icon: 'tag',
            url: file_server_url + '/' + async_modules_path + "tinymse_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "duration",
            name: 'Duration',
            icon: 'number_gh_element',
            url: file_server_url + '/' + async_modules_path + "duration_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "user",
            name: 'User',
            icon: 'user_gh_element',
            url: file_server_url + '/' + async_modules_path + "user_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "app",
            name: 'App',
            icon: 'app',
            url: file_server_url + '/' + async_modules_path + "application_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "field",
            name: 'Field',
            icon: 'field_gh_element',
            url: file_server_url + '/' + async_modules_path + "field_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "available",
            name: 'Available',
            icon: 'availible_gh_element',
            url: file_server_url + '/' + async_modules_path + "available_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "view_list",
            name: 'View List',
            icon: 'view_list',
            url: file_server_url + '/' + async_modules_path + "view_list_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "calculator",
            name: 'Calculator',
			icon: 'calculator',
            url: file_server_url + '/' + async_modules_path + "calculator_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "string_join",
            name: 'String Joiner',
            icon: 'string_join_gh_element',
            url: file_server_url + '/' + async_modules_path + "string_joiner_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "signature",
            name: 'Signature',
            icon: 'signature',
            url: file_server_url + '/' + async_modules_path + "signature_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "sendEmail",
            name: 'Send Email',
            icon: 'send_email_gh_element',
            url: file_server_url + '/' + async_modules_path + "send_email_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "boolean",
            name: 'Yes/No',
			icon: 'boolen_gh_element',
            url: file_server_url + '/' + async_modules_path + "boolean_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "product_gallery",
            name: 'Product gallery',
            icon: 'product_gallery',
            url: file_server_url + '/' + async_modules_path + "product_gallery_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "online_inventory",
            name: 'Online inventory',
            icon: 'slab',
            url: file_server_url + '/' + async_modules_path + "online_inventory_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "3d_edges",
            name: '3D Edges',
            icon: '3d_edges_gh_element',
            url: file_server_url + '/' + async_modules_path + "3d_edges_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "color_list",
            name: 'Color list',
            icon: 'circular_gh_element',
            url: file_server_url + '/' + async_modules_path + "color_list_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "go_to_link",
            name: 'Go to Link',
            icon: 'go_to_link',
            url: file_server_url + '/' + async_modules_path + "go_to_link_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "go_to_view",
            name: 'Go to View',
            icon: 'go_to_view',
            url: file_server_url + '/' + async_modules_path + "go_to_view_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "range",
            name: 'Range',
			icon: 'range_gh_element',
            url: file_server_url + '/' + async_modules_path + "range_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "barcode",
            name: 'Barcode',
            icon: 'barcode_gh_element',
            url: file_server_url + '/' + async_modules_path + "barcode_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "item_remote_add",
            name: 'Item remote add',
            icon: 'remote_add_gh_element',
            url: file_server_url + '/' + async_modules_path + "item_remote_add_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "item_remote_update",
            name: 'Item remote update',
            icon: 'remote_update_gh_element',
            url: file_server_url + '/' + async_modules_path + "item_remote_update_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "timeline",
            name: 'Timeline',
			icon: 'timeline',
            url: file_server_url + '/' + async_modules_path + "timeline_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "delete_item",
            name: 'Delete Item',
            icon: 'rubbish',
            url: file_server_url + '/' + async_modules_path + "delete_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "print_doc",
            name: 'Print document',
            icon: 'print',
            url: file_server_url + '/' + async_modules_path + "print_doc_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "open_item",
            name: 'Open Item',
            icon: 'delete',
            private: true,
            url: file_server_url + '/' + async_modules_path + "open_item_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "edit_template",
            name: "Edit template",
            icon: "delete",
            private: true,
            url: file_server_url + '/' + async_modules_path + "edit_template_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "open_app",
            private: true,
            name: 'Open App',
            icon: 'delete',
            url: file_server_url + '/' + async_modules_path + "open_app_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "user_settings",
            private: true,
            name: 'User Settings',
            icon: 'delete',
            url: file_server_url + '/' + async_modules_path + "user_settings_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "app_sharing",
            name: 'Sharing',
            icon: 'sharing',
            url: file_server_url + '/' + async_modules_path + "sharing_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "app_constructor",
            private: true,
            name: 'App constructor',
			icon: 'app_constructor',
            url: file_server_url + '/' + async_modules_path + "app_constructor_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "app_settings",
            name: 'App Settings',
			icon: 'configuration',
            url: file_server_url + '/' + async_modules_path + "app_settings_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "export_csv",
            name: 'Export CSV',
            icon: 'export_csv',
            url: file_server_url + '/' + async_modules_path + "export_csv.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "import_csv",
            name: "Import CSV",
            icon: "import_csv",
            url: file_server_url + '/' + async_modules_path + "import_csv.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "add_items",
            name: 'Add Items',
            icon: 'plus',
            url: file_server_url + '/' + async_modules_path + "add_items_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "update_items",
            name: 'Update Items',
            icon: 'update',
            url: file_server_url + '/' + async_modules_path + "update_items_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "install_app",
            name: 'Install',
            icon: 'install',
            url: file_server_url + '/' + async_modules_path + "install_app_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "search_action",
            name: 'Search',
            icon: 'search',
            url: file_server_url + '/' + async_modules_path + "search_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "filter_table",
            name: 'Table filter',
            icon: 'filter',
            url: file_server_url + '/' + async_modules_path + "filter_table_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "slider",
            name: 'Slider',
            icon: 'slider',
            url: file_server_url + '/' + async_modules_path + "slider_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "clone_item",
            name: 'Clone Item',
            icon: 'double_plus',
            url: file_server_url + '/' + async_modules_path + "clone_item_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "close",
            name: 'Close',
            icon: 'cross',
            url: file_server_url + '/' + async_modules_path + "close_action.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "phone",
            name: 'Phone',
            icon: 'phone_thin',
            url: file_server_url + '/' + async_modules_path + "phone_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "link",
            name: 'Link',
            icon: 'link_gh_element',
            url: file_server_url + '/' + async_modules_path + "link_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "sheduling",
            name: 'Sheduling',
            icon: 'scheduling',
            url: file_server_url + '/' + async_modules_path + "sheduling_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "qrcode",
            name: 'QR Code',
            icon: 'qr_code',
            url: file_server_url + '/' + async_modules_path + "qrcode_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "graph2d",
            name: 'Graph',
            icon: 'graph',
            url: file_server_url + '/' + async_modules_path + "graph2d_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "quote_tool",
            name: 'Quote tool',
            icon: 'quoters',
            url: file_server_url + '/' + async_modules_path + "quote_tool_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "cards",
            name: 'Cards',
            icon: 'cards',
            url: file_server_url + '/' + async_modules_path + "cards_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "jsonConstructor",
            name: 'Json Constructor',
            icon: 'button',
            url: file_server_url + '/' + async_modules_path + "json_constructor_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "button",
            name: 'Button',
            icon: 'button',
            js: "https://gudhub.com/modules/button_action/button_action.js?t=1",
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: "editorjs",
            name: 'EditorJS',
            icon: 'code_editor',
            js: "https://gudhub.com/modules/Editor-Js/dist/main.js?t=2",
            css: "https://gudhub.com/modules/Editor-Js/dist/style.css?t=2",
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: "filter_advanced",
            name: 'Filter Advanced',
            icon: 'filter_advanced',
            url: file_server_url + '/' + async_modules_path + "filter_advanced_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "code_editor",
            name: 'Code Editor',
            icon: 'code_editor',
            url: file_server_url + '/' + async_modules_path + "code_editor_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "icon",
            name: 'Icon',
            icon: 'icon_gh_element',
            url: file_server_url + '/' + async_modules_path + "icon_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "quoteRequest",
            name: 'Quote Request',
            icon: 'invoices',
            url: file_server_url + '/' + async_modules_path + "quote_request_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "view_container",
            name: 'View Container',
            icon: 'pencil',
            url: file_server_url + '/' + async_modules_path + "view_container_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "element_ref",
            name: "Element Reference",
            icon: "cloudSync_gh_element",
            url: file_server_url + '/' + async_modules_path + "element_ref_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "quote_tool_objects_renderer",
            name: 'Quote Tool Renderer',
            icon: 'l_counter',
            url: file_server_url + '/' + async_modules_path + "quote_tool_objects_renderer_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "quote_tool_objects_renderer_generator",
            name: 'Quote Tool Parts Generator',
            icon: 'l_counter_arrow',
            url: file_server_url + '/' + async_modules_path + "quote_tool_objects_renderer_generator_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "trigger",
            name: 'Trigger',
			icon: 'job',
            url: file_server_url + '/' + async_modules_path + "trigger_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "voting",
            name: 'Voting',
            icon: 'like_gh_element',
            url: file_server_url + '/' + async_modules_path + "voting_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "view_tabs",
            name: "View Tab",
            icon: "tabs",
            url: file_server_url + '/' + async_modules_path + "view_tabs.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "filter_tabs",
            name: "Filter Tabs",
            icon: "filter_tabs_gh_element",
            url: file_server_url + '/' + async_modules_path + "filter_tabs.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "gps_coords",
            name: 'GPS Coords',
            icon: 'location_gh_element',
            url: file_server_url + '/' + async_modules_path + "gps_coords.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "google_map",
            name: 'Google Map',
            icon: 'location',
            url: file_server_url + '/' + async_modules_path + "google_map_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "data_migrations",
            name: "Data migrations",
            icon: "view_list_gh_element",
            url: file_server_url + '/' + async_modules_path + "data_migrations.js",
            type: 'gh_element',
            technology: 'angular'
        }, {
            data_type: "additional_settings",
            name: "Additional Settings",
            icon: "",
            private: true,
            url: file_server_url + '/' + async_modules_path + "gh_additional_settings_data.js",
            type: 'gh_element',
            technology: 'angular'
        }, {
            data_type: "send_request",
            name: "Send Request",
            icon: "send_request_gh_element",
            url: file_server_url + '/' + async_modules_path + "send_request_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "webcam",
            name: "Web camera",
            icon: "webcam_gh_element",
            url: file_server_url + '/' + async_modules_path + "webcam_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "json_viewer",
            name: "JSON viewer",
            icon: "json_gh_element",
            url: file_server_url + '/' + async_modules_path + "json_viewer_data.js",
            type: 'gh_element',
            technology: 'angular'
        }, {
            data_type: "notifications",
            name: "Notifications",
            icon: "full_gh_element",
            url: file_server_url + '/' + async_modules_path + "notifications_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "api",
            name: "API",
            icon: "job",
            url: file_server_url + '/' + async_modules_path + "api_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "smart_input",
            name: "Smart Input",
            icon: "roket",
            url: file_server_url + '/' + async_modules_path + "smart_input_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "json_editor",
            name: "JSON Editor",
            icon: "code",
            url: file_server_url + '/' + async_modules_path + "json_editor_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "grapes_html_editor",
            name: 'Grapes Html Editor',
            icon: 'code_editor',
            url: file_server_url + '/' + async_modules_path + "grapes_html_editor_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "quiz",
            name: 'Quiz',
            icon: 'quiz_gh_element',
            url: file_server_url + '/' + async_modules_path + "quiz_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "password_input",
            name: "Password",
            icon: "lock_gh_element",
            url: file_server_url + '/' + async_modules_path + "password_input_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "vs_code",
            name: 'VS Code',
            icon: 'code_editor',
            url: file_server_url + '/' + async_modules_path + "vs_code_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "nested_list",
            name: 'Nested List',
		    icon: 'scheduling',
            js: "https://gudhub.com/modules/Nested-List/dist/main.js?t=2",
            css: "https://gudhub.com/modules/Nested-List/dist/style.css?t=2",
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: "countertop_smart_quote",
            name: 'Countertop Smart Quote',
            icon: 'quoters',
            url: file_server_url + '/' + async_modules_path + "countertop_smart_quote_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: "markdown_viewer",
            name: 'Markdown viewer',
            icon: 'code_editor',
            js: "https://gudhub.com/modules/markdown-it-gh-element/dist/main.js?t=1",
            css: "https://gudhub.com/modules/markdown-it-gh-element/dist/style.css?t=1",
            type: 'gh_element',
            technology: "class"
        },
        {
            data_type: "html_viewer",
            name: 'HTML Viewer',
            icon: 'code_editor',
            js: "https://gudhub.com/modules/HTML-Viewer/dist/main.js?t=1",
            css: "https://gudhub.com/modules/HTML-Viewer/dist/style.css?t=1",
            type: 'gh_element',
            technology: "class"
        },
        {
            data_type: "element_customizer",
            name: "Element Customizer",
            icon: "pencil",
            url: file_server_url + '/' + async_modules_path + "element_customizer_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: 'task',
            name: 'Task',
            icon: 'table',
            url: file_server_url + '/' + async_modules_path + 'task_data.js',
            type: 'gh_element',
            technology: 'angular'
        },
        {
            data_type: 'cron_picker',
            name: 'Cron Picker',
            icon: 'table',
            js: 'https://gudhub.com/modules/Cron-Picker/dist/main.js?t=2',
            css: 'https://gudhub.com/modules/Cron-Picker/dist/style.css?t=2',
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: 'balance_sheet',
            name: 'Balance Sheet',
            icon: 'table',
            js: 'https://gudhub.com/modules/balance-sheet/dist/main.js?t=2',
            css: 'https://gudhub.com/modules/balance-sheet/dist/style.css?t=2',
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: 'quote_form',
            name: 'Quote Form',
            icon: 'table',
            js: 'https://gudhub.com/modules/countertop-quote-form/dist/main.js',
            css: 'https://gudhub.com/modules/countertop-quote-form/dist/style.css',
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: 'static_nested_list',
            name: 'Nested Filter',
            icon: 'scheduling',
            js: 'https://gudhub.com/modules/nested-filter/dist/main.js?t=1',
            css: 'https://gudhub.com/modules/nested-filter/dist/style.css?t=1',
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: 'conversations',
            name: 'Conversations',
            icon: 'timeline',
            js: 'https://gudhub.com/modules/conversation/dist/main.js?t=1',
            css: 'https://gudhub.com/modules/conversation/dist/style.css?t=1',
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: 'study_journal',
            name: 'Study Journal',
            icon: 'timeline',
            js: 'https://gudhub.com/modules/Study-Journal/dist/main.js?t=1',
            css: 'https://gudhub.com/modules/Study-Journal/dist/style.css',
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: 'study_schedule',
            name: 'Study Schedule',
            icon: 'timeline',
            js: 'https://gudhub.com/modules/Study-Schedule/dist/main.js?t=1',
            css: 'https://gudhub.com/modules/Study-Schedule/dist/style.css?t=1',
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: 'avatar',
            name: 'Avatar',
            icon: 'user',
            js: 'https://gudhub.com/modules/Gh-Avatar/dist/main.js?t=1',
            css: 'https://gudhub.com/modules/Gh-Avatar/dist/style.css?t=1',
            type: 'gh_element',
            technology: 'class'
        },
        {
            data_type: "text_area",
            name: "Text Area",
            icon: "text_icon",
            js: "https://gudhub.com/modules/text-area-ghe/dist/main.js?t=3",
            css: "https://gudhub.com/modules/text-area-ghe/dist/style.css",
            type: "gh_element",
            technology: "class",
        },
        {
            data_type: "resource_calendar",
            name: "Resource Сalendar",
            icon: "calendar",
            url: file_server_url + '/' + async_modules_path + "resource_calendar_data.js",
            type: 'gh_element',
            technology: 'angular'
        },
        /* AUTOMATION MODULES */
        /*
            We have next types for automations:
            - API
            - GhElement
            - Quiz
            - SmartInput
            - Trigger
            - Task
            - Iterator
        */
        {
            data_type: 'API',
            name: 'API',
            url: file_server_url + '/' + automation_modules_path + 'api_node.js',
            type: 'automation',
            icon: 'automation_api',
            private: true
        },
        {
            data_type: 'Calculator',
            name: 'Calculator',
            url: file_server_url + '/' + automation_modules_path + 'calculator.js',
            type: 'automation',
            icon: 'automation_calculator'
        },
        {
            data_type: 'CompareItems',
            name: 'Compare Items',
            url: file_server_url + '/' + automation_modules_path + 'compare_items.js',
            type: 'automation',
            icon: 'automation_compare_items'
        },
        {
            data_type: 'Constants',
            name: 'Constants',
            url: file_server_url + '/' + automation_modules_path + 'constants.js',
            type: 'automation',
            icon: 'automation_constants'
        },
        {
            data_type: 'CreateFiles',
            name: 'Create Files',
            url: file_server_url + '/' + automation_modules_path + 'create_files.js',
            type: 'automation',
            icon: 'automation_create_files'
        },
        {
            data_type: 'CreateItemsApi',
            name: 'Create Items Api',
            url: file_server_url + '/' + automation_modules_path + 'create_item_api.js',
            type: 'automation',
            icon: 'automation_create_items_api'
        },
        {
            data_type: 'FileDuplicate',
            name: 'File Duplicate',
            url: file_server_url + '/' + automation_modules_path + 'file_duplicate.js',
            type: 'automation',
            icon: 'automation_file_duplicate'
        },
        {
            data_type: 'Filter',
            name: 'Filter',
            url: file_server_url + '/' + automation_modules_path + 'filter_node.js',
            type: 'automation',
            icon: 'filter'
        },
        {
            data_type: 'GetItemByItemRef',
            name: 'Get Item By Item Ref',
            url: file_server_url + '/' + automation_modules_path + 'get_item_by_item_ref.js',
            type: 'automation',
            icon: 'automation_get_item_by_item_ref'
        },
        {
            data_type: 'GetItems',
            name: 'Get Items',
            url: file_server_url + '/' + automation_modules_path + 'get_items.js',
            type: 'automation',
            icon: 'automation_get_items'
        },
        {
            data_type: 'GhElementNode',
            name: 'Gh Element Node',
            url: file_server_url + '/' + automation_modules_path + 'gh_element_node.js',
            type: 'automation',
            icon: 'automation_gh_element_node',
            private: true,
            created_for: ['GhElement']
        },
        {
            data_type: 'IfCondition',
            name: 'If Condition',
            url: file_server_url + '/' + automation_modules_path + 'if_condition.js',
            type: 'automation',
            icon: 'automation_if_condition'
        },
        {
            data_type: 'ItemConstructor',
            name: 'Item Constructor',
            url: file_server_url + '/' + automation_modules_path + 'item_constructor.js',
            type: 'automation',
            icon: 'automation_item_constructor'
        },
        {
            data_type: 'ItemDestructor',
            name: 'Item Destructor',
            url: file_server_url + '/' + automation_modules_path + 'item_destructor.js',
            type: 'automation',
            icon: 'automation_item_destructor'
        },
        {
            data_type: 'JSONScheme',
            name: 'JSON Scheme',
            url: file_server_url + '/' + automation_modules_path + 'json_scheme.js',
            type: 'automation',
            icon: 'automation_json_scheme'
        },
        {
            data_type: 'MergeItems',
            name: 'Merge Items',
            url: file_server_url + '/' + automation_modules_path + 'merge_items.js',
            type: 'automation',
            icon: 'automation_merge_items'
        },
        {
            data_type: 'MessageConstructor',
            name: 'Message Constructor',
            url: file_server_url + '/' + automation_modules_path + 'message_constructor.js',
            type: 'automation',
            icon: 'automation_message_constructor'
        },
        {
            data_type: 'ObjectToItem',
            name: 'Object To Item',
            url: file_server_url + '/' + automation_modules_path + 'obj_to_item.js',
            type: 'automation',
            icon: 'automation_object_to_item'
        },
        {
            data_type: 'ObjectConstructor',
            name: 'Object Constructor',
            url: file_server_url + '/' + automation_modules_path + 'object_constructor.js',
            type: 'automation',
            icon: 'automation_object_constructor'
        },
        {
            data_type: 'ObjectDestructor',
            name: 'Object Destructor',
            url: file_server_url + '/' + automation_modules_path + 'object_destructor.js',
            type: 'automation',
            icon: 'automation_object_destructor'
        },
        {
            data_type: 'PopulateElement', // Available for GH Elements only
            name: 'Populate Element',
            url: file_server_url + '/' + automation_modules_path + 'populate_element.js',
            type: 'automation',
            icon: 'automation_populate_element',
            private: true,
            created_for: ['GhElement']
        },
        {
            data_type: 'PopulateItems',
            name: 'Populate Items',
            url: file_server_url + '/' + automation_modules_path + 'populate_items.js',
            type: 'automation',
            icon: 'automation_populate_items'
        },
        {
            data_type: 'PopulateWithDate',
            name: 'Populate With Date',
            url: file_server_url + '/' + automation_modules_path + 'populate_with_date.js',
            type: 'automation',
            icon: 'automation_populate_with_date'
        },
        {
            data_type: 'PopulateWithItemRef',
            name: 'Populate with Item Ref',
            url: file_server_url + '/' + automation_modules_path + 'populate_with_item_ref.js',
            type: 'automation',
            icon: 'automation_populate_with_item_ref'
        },
        {
            data_type: 'PopUpForm', // Available for Quiz Node, GH Element, Smart Input
            name: 'Pop Up Form',
            url: file_server_url + '/' + automation_modules_path + 'popup_form.js',
            type: 'automation',
            icon: 'automation_pop_up_form',
            private: true,
            created_for: ['Quiz', 'GhElement', 'SmartInput', 'Iterator']
        },
        {
            data_type: 'QuizForm', // Available for Quiz Node only
            name: 'Quiz Form',
            url: file_server_url + '/' + automation_modules_path + 'quiz_form.js',
            type: 'automation',
            icon: 'automation_quiz_form',
            private: true,
            created_for: ['Quiz']
        },
        {
            data_type: 'QuizNode',
            name: 'Quiz Node',
            url: file_server_url + '/' + automation_modules_path + 'quiz_node.js',
            type: 'automation',
            icon: 'automation_quiz_node',
            private: true
        },
        {
            data_type: 'Request',
            name: 'Request',
            url: file_server_url + '/' + automation_modules_path + 'request_node.js',
            type: 'automation',
            icon: 'automation_request'
        },
        {
            data_type: 'Response', // Available for API only
            name: 'Response', 
            url: file_server_url + '/' + automation_modules_path + 'response_node.js',
            type: 'automation',
            icon: 'automation_response',
            private: true,
            created_for: ['API']
        },
        {
            data_type: 'SmartInput',
            name: 'Smart Input',
            url: file_server_url + '/' + automation_modules_path + 'smart_input.js',
            type: 'automation',
            icon: 'automation_smart_input',
            private: true
        },
        {
            data_type: 'Trigger',
            name: 'Trigger',
            url: file_server_url + '/' + automation_modules_path + 'trigger_node.js',
            type: 'automation',
            icon: 'automation_trigger',
            private: true
        },
        {
            data_type: 'TwilioSMS',
            name: 'Twilio SMS',
            url: file_server_url + '/' + automation_modules_path + 'twilio_sms.js',
            type: 'automation',
            icon: 'automation_twilio'
        },
        {
            data_type: 'TwilioAuth',
            name: 'Twilio Auth',
            url: file_server_url + '/' + automation_modules_path + 'twilio_auth.js',
            type: 'automation',
            icon: 'table'
        },
        {
            data_type: 'TwilioDevice',
            name: 'Twilio Device',
            url: file_server_url + '/' + automation_modules_path + 'twilio_device.js',
            type: 'automation',
            icon: 'table'
        },
        {
            data_type: 'UpdateItemsApi',
            name: 'Update Items Api',
            url: file_server_url + '/' + automation_modules_path + 'update_items_api.js',
            type: 'automation',
            icon: 'automation_update_items_api'
        },
        {
            data_type: 'GoogleCalendar',
            name: 'Google Calendar',
            url: file_server_url + '/' + automation_modules_path + 'google_calendar.js',
            type: 'automation',
            icon: 'calendar'
        },
        {
            data_type: 'VerifyEmail',
            name: 'Verify email',
            url: file_server_url + '/' + automation_modules_path + 'verify_email.js',
            type: 'automation',
            icon: 'check_in_circle'
        },
        {   
            data_type: 'Iterator',
            name: 'Iterator',
            url: file_server_url + '/' + automation_modules_path + 'iterator.js',
            type: 'automation',
            icon: 'update'
        },
        {
            data_type: 'IteratorInput',
            name: 'Iterator Input',
            url: file_server_url + '/' + automation_modules_path + 'iterator_input.js',
            type: 'automation',
            icon: 'arrow_right',
            private: true
        },
        {
            data_type: 'IteratorOutput',
            name: 'Iterator Output',
            url: file_server_url + '/' + automation_modules_path + 'iterator_output.js',
            type: 'automation',
            icon: 'arrow_right',
            private: true
        },
        {
            data_type: 'SendEmail',
            name: 'Send email',
            url: file_server_url + '/' + automation_modules_path + 'send_email.js',
            type: 'automation',
            icon: 'email'
        },
        {
            data_type: 'FileReader',
            name: 'File Reader',
            url: file_server_url + '/' + automation_modules_path + 'file_reader.js',
            type: 'automation',
            icon: 'file'
        },
        {
            data_type: 'WebsitesChecker',
            name: 'Websites Checker',
            url: file_server_url + '/' + automation_modules_path + 'websites_checker.js',
            type: 'automation',
            icon: 'world'
        },
        {
            data_type: 'VoiceMachineDetection',
            name: 'Voice Machine Detection',
            url: file_server_url + '/' + automation_modules_path + 'voice_machine_detection.js',
            type: 'automation',
            icon: 'automation_calculator'
        },
        {
            data_type: 'Task',
            name: 'Task',
            url: file_server_url + '/' + automation_modules_path + 'task.js',
            type: 'automation',
            icon: 'automation_calculator',
            private: true
        },
        {
            data_type: 'DeleteItems',
            name: 'Delete Items',
            url: file_server_url + '/' + automation_modules_path + 'delete_items.js',
            type: 'automation',
            icon: 'rubbish'
        },
        {
            data_type: 'GoToItem',
            name: 'Go To Item',
            url: file_server_url + '/' + automation_modules_path + 'go_to_item.js',
            type: 'automation',
            icon: 'cursor_point'
        },
        {
            data_type: 'FireWorks',
            name: 'Fire Works',
            url: file_server_url + '/' + automation_modules_path + 'fireworks_node.js',
            type: 'automation',
            icon: 'weeding_party'
        },
        {
            data_type: 'SendMessage',
            name: 'Send Message',
            url: file_server_url + '/' + automation_modules_path + 'send_message.js',
            type: 'automation',
            icon: 'speech_bubble'
        },
        {
            data_type: 'TurboSMS',
            name: 'Turbo SMS',
            url: file_server_url + '/' + automation_modules_path + 'turbo_sms.js',
            type: 'automation',
            icon: 'email'
        }
    ]
}